import { render, staticRenderFns } from "./LayoutContentHorizontalNavInbox.vue?vue&type=template&id=09c12eb0&scoped=true&"
import script from "./LayoutContentHorizontalNavInbox.vue?vue&type=script&lang=js&"
export * from "./LayoutContentHorizontalNavInbox.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentHorizontalNavInbox.vue?vue&type=style&index=0&id=09c12eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c12eb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBarNavIcon,VCard,VCardText,VCol,VIcon,VImg,VOverlay,VRow})
